import React from "react";
import { useRouteMatch } from "react-router-dom";

import { GET_FOLLOWERS } from 'graphql/query/followers-gql';

import Collection from 'components/collection';

import { useBreadCrumbs } from "components/use-hooks";
import { Tables } from "components/layout";
import { Localize } from "components/service";



const CollectionFollowersSubPage = ({ collection }) => {

    const basePath = Collection.Const.basePath;
    const tableHelper = Collection.Helpers.TableFollowers();


    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Collections" }).props.children,
            path: `${ basePath }`
        },
        {
            label: collection?.title ?? <strong>the collection has no title</strong>,
            path: `${ basePath }/${ collection?.id }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_Followers" }).props.children,
            path: `${ basePath }/${ collection?.id }/followers`
        },
    ]

    useBreadCrumbs(breadcrumbs);

    const routeUrl = `${ basePath }/${ collection?.id }/followers`;
    let match = useRouteMatch(`${ routeUrl }/page/:pageNum`);

    const objOrderBy = [ { column: "ID", order: "DESC" } ];



    return (

        <Tables.Main
            model="followersBy"
            query={ GET_FOLLOWERS }
            varSet={ { perPage: 30, id: collection?.id, model: 'Collection' } }
            routeUrl={ routeUrl }
            currentPage={ match ? parseInt(match.params.pageNum) : 1 }
            objOrderBy={ objOrderBy }
            tableHelper={ tableHelper }
        >
            <div className="table-action-bar">

                <div className="col"> </div>

                <div className="col"> </div>
            </div>
        </Tables.Main>
    )
};

export default CollectionFollowersSubPage;